/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component } from '@angular/core';

/**
 * extend this class if a custom control need be called by the parent component - the main workflow component
 * See XrxMultiTranslationComponent for how to extend this class with injector
 */
@Component({
  selector: 'xrx-base-control',
  template: '',
  standalone: false,
})
export abstract class XrxControlBaseComponent {
  abstract validate(): void;
}
